module.exports = __webpack_public_path__ + "img/amount_failed.b93fbd22.png";